import React from 'react';
import { isNil } from 'ramda';
import { Tabs } from 'antd';
import CreateTab from './documentFormTabs/CreateTab';
import VariablesTab from './documentFormTabs/VariablesTab';
import CommentsTab from './documentFormTabs/CommentsTab';

const TabTitle = ({ icon, title, className }) => {
  return (
    <div className={`${className} flex items-center`}>
      {!isNil(icon) && (
        <div
          className="w-25px h-25px mr-2.5 icon-tab"
          // eslint-disable-next-line no-restricted-syntax
          style={{
            WebkitMaskImage: `url(/icons/${icon})`,
            maskImage: `url(/icons/${icon})`
          }}
        />
      )}

      <span className="uppercase font-semibold text-sm">{title}</span>
    </div>
  );
};

const DocumentFormTabs = (props) => {
  const {
    comments,
    showSettings,
    activeMainTabKey,
    setActiveMainTabKey
  } = props;

  const tabItems = [
    {
      key: '1',
      label: (
        <TabTitle
          className="create-tab-button"
          icon="icon-layer-plus.svg"
          title="Création"
        />
      ),
      children: <CreateTab {...props} />
    },
    {
      key: '2',
      label: (
        <TabTitle
          icon="icon-comment-quote.svg"
          title="Commentaires"
        />
      ),
      children: <CommentsTab comments={comments} />
    },
    {
      key: '3',
      label: (
        <TabTitle
          className="variables-tab-button"
          icon="icon-pen-field.png"
          title="Variables"
        />
      ),
      children: <VariablesTab />
    }
  ];

  return (
    <div className={`bg-white w-full p-6 shadow-lg ${showSettings ? 'visible' : 'invisible'}`}>
      <Tabs
        activeKey={activeMainTabKey}
        onChange={setActiveMainTabKey}
        items={tabItems}
      />
    </div>
  );
};

export default DocumentFormTabs;
